// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mobileTippyBreakpoint } from "@pace/App/ComponentExtensions/Tippy/TippyPopupExtensions";
import { headerText } from "@pace/App/SharedStyles/AutoCompleteSharedStyles";
import { createProductDescriptionStyles } from "@pace/App/SharedStyles/productDescriptionStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@pace/App/SharedStyles/smallHeadingAndTextStyles";
import { autocompleteProductsStyles } from "@pace/Overrides/Widgets/Header/AutocompleteProducts";
import { color, ellipsis, mergeWithCss, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.headerText = {
    ...mergeWithCss(headerText, {
        css: css`
            margin: 0 0 12px 0;
            display: none;
            ${xScreen("lte", mobileTippyBreakpoint)} {
                display: block;
            }
        `,
    }),
};

autocompleteProductsStyles.container = {
    css: css`
        display: flex;
        gap: 12px;
        &:not(:last-of-type) {
            margin-bottom: 16px;
        }
    `,
};

autocompleteProductsStyles.focusedContainer = {
    ...mergeWithCss(autocompleteProductsStyles.container, {
        css: css`
            background-color: ${color("common.ui8", 0.3)};
        `,
    }),
};

autocompleteProductsStyles.imageClickable = {
    css: css`
        max-width: 89px;
        max-height: 89px;
        flex-basis: 89px;
    `,
};

autocompleteProductsStyles.image = {
    css: css`
        width: 89px;
        min-width: 89px;
        height: 89px;
        cursor: pointer;
        & > img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
        }
    `,
};
autocompleteProductsStyles.infoGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 4px;
    `,
};

autocompleteProductsStyles.titleLink = {
    ...mergeWithCss(createProductDescriptionStyles().productDetailLink, {
        css: css`
            align-items: baseline;
        `,
        typographyProps: {
            css: css`
                &&& {
                    font-size: 12px;
                }
            `,
        },
    }),
};

autocompleteProductsStyles.productNumbersContainer = {
    css: css`
        display: flex;
        column-gap: 8px;
        margin-bottom: 8px;
        ${xScreen("lte", mobileTippyBreakpoint)} {
            flex-direction: column;
            margin-bottom: 12px;
        }
    `,
};

autocompleteProductsStyles.erpNumberText = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                width: auto;
                max-width: 50%;
                ${xScreen("lte", mobileTippyBreakpoint)} {
                    width: 100%;
                    max-width: none;
                }
            `,
        },
        text: {
            color: "common.ui5",
            css: css`
                line-height: 16px;
                ${ellipsis(1)};
            `,
        },
        heading: {
            css: css`
                line-height: 16px;
            `,
        },
    }),
};

autocompleteProductsStyles.actions = {
    productQuantityOrderedStyles: {
        qtyFieldStyles: {
            multipleSaleQtyToolTip: {
                zIndex: 9999,
            },
        },
    },
    productAddToCartButtonStyles: {
        mergeCss: true,
        css: css`
            ${({ showMultipleSaleQtyTooltip }: any) =>
                !showMultipleSaleQtyTooltip &&
                `
            padding: 0 32px;
        `}
        `,
    },
};
